module.exports = __webpack_public_path__ + "static/media/framework_img.128d6a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/framework_img.png
// module id = 127
// module chunks = 0